"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Circle = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var Icon_styled_1 = require("../Icon.styled");
exports.Circle = function (props) {
    var _a;
    return (React.createElement(Icon_styled_1.StyledSvg, tslib_1.__assign({ width: "30px", height: "30px", viewBox: "0 0 30 30", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("g", { fill: props.fill || 'none', stroke: (_a = (props.fill && props.stroke)) !== null && _a !== void 0 ? _a : 'none', strokeWidth: props.strokeWidth },
            React.createElement("g", { id: "Group-6-Copy-2", transform: "translate(1.000000, 1.000000)" },
                React.createElement("circle", { id: "Oval-4-Copy-7", cx: "14", cy: "14", r: "14" })))));
};
//# sourceMappingURL=circle.js.map